var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStreetLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.256,
    x2: 97.187,
    xlinkHref: "#lg1",
    y1: 121.163,
    y2: 163.453
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.859,
    x2: 70.246,
    xlinkHref: "#lg2",
    y1: 239.598,
    y2: 233.147
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.31,
    x2: 404.66,
    y1: 114.28,
    y2: 200.63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.24,
    x2: 353.24,
    y1: 199.052,
    y2: 157.311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.199,
    x2: 356.386,
    xlinkHref: "#lg1",
    y1: 102.319,
    y2: 173.502
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.957,
    x2: 323.763,
    xlinkHref: "#lg3",
    y1: 41.605,
    y2: 140.303
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.92,
    x2: 367.929,
    xlinkHref: "#lg4",
    y1: 303.018,
    y2: 303.018
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(0 1 -1 0 172.916 583.916)",
    gradientUnits: "userSpaceOnUse",
    x1: -399.789,
    x2: -374.78,
    xlinkHref: "#lg4",
    y1: -55.459,
    y2: -55.459
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(0 1 -1 0 172.916 583.916)",
    gradientUnits: "userSpaceOnUse",
    x1: -399.789,
    x2: -374.78,
    xlinkHref: "#lg4",
    y1: -305.19,
    y2: -305.19
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 207.391 256.146)",
    gradientUnits: "userSpaceOnUse",
    x1: 49.183,
    x2: 74.192,
    xlinkHref: "#lg4",
    y1: -38.188,
    y2: -38.188
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -83.23 791.307)",
    gradientUnits: "userSpaceOnUse",
    x1: -740.995,
    x2: -715.986,
    xlinkHref: "#lg4",
    y1: 4.842,
    y2: 4.842
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.913,
    x2: 130.232,
    xlinkHref: "#lg3",
    y1: 187.427,
    y2: 325.919
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.419,
    x2: 49.059,
    xlinkHref: "#lg2",
    y1: 146.928,
    y2: 74.63
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.419,
    x2: 49.059,
    xlinkHref: "#lg2",
    y1: 199.701,
    y2: 127.403
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.419,
    x2: 49.059,
    xlinkHref: "#lg2",
    y1: 299.419,
    y2: 227.121
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.441,
    x2: 52.441,
    xlinkHref: "#lg3",
    y1: 113.002,
    y2: 145.904
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.441,
    x2: 52.441,
    xlinkHref: "#lg3",
    y1: 212.404,
    y2: 245.306
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.441,
    x2: 52.441,
    xlinkHref: "#lg3",
    y1: 59.338,
    y2: 92.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m65.67 364.168c-16.158 0-29.256-13.099-29.256-29.256v-111.025c0-82.105 66.797-148.903 148.902-148.903h54.684c16.157 0 29.256 13.099 29.256 29.256s-13.099 29.257-29.256 29.257h-54.684c-49.841 0-90.39 40.549-90.39 90.39v111.024c0 16.158-13.099 29.257-29.256 29.257z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.413 223.887v111.024c0 16.158 13.098 29.256 29.256 29.256 16.157 0 29.257-13.099 29.257-29.256v-111.024c0-33.6 18.442-62.955 45.721-78.533l-38.37-38.37h-9.086c-34.558 27.293-56.778 69.551-56.778 116.903z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 353.24,
    cy: 149.21,
    fill: "url(#SVGID_3_)",
    r: 87.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.24 61.218c-48.597 0-87.992 39.395-87.992 87.992 0 8.103 1.118 15.94 3.168 23.391l61.433 61.433c7.451 2.05 15.288 3.168 23.391 3.168 48.597 0 87.992-39.395 87.992-87.992s-39.395-87.992-87.992-87.992z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m421.698 177.825h-136.915c-28.762 0-52.079-23.317-52.079-52.079v-12.997h241.073v12.997c0 28.762-23.317 52.079-52.079 52.079z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.033 97.058c-.109 13.015-5.424 24.772-13.959 33.32-8.637 8.625-20.561 13.961-33.727 13.961h-184.889c-14.499 0-28.999.655-43.452 1.966l-32.964 2.785c-21.399 1.808-39.767-15.074-39.767-36.55 0-26.276 18.408-48.959 44.121-54.369l4.386-.923c30.544-5.512 61.52-8.285 92.556-8.285h159.168c26.453 0 48.748 21.643 48.527 48.095z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.24 334.911c-7.5 0-13.579-6.08-13.579-13.579v-36.63c0-7.499 6.08-13.579 13.579-13.579 7.499 0 13.579 6.08 13.579 13.579v36.63c0 7.5-6.079 13.579-13.579 13.579z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.48 194.447c0-7.499 6.08-13.579 13.579-13.579h36.63c7.499 0 13.579 6.08 13.579 13.579 0 7.499-6.08 13.579-13.579 13.579h-36.63c-7.499-.001-13.579-6.08-13.579-13.579z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.212 194.447c0-7.499 6.08-13.579 13.579-13.579h36.63c7.499 0 13.579 6.08 13.579 13.579 0 7.499-6.08 13.579-13.579 13.579h-36.63c-7.499-.001-13.579-6.08-13.579-13.579z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.917 293.77c-5.303-5.303-5.303-13.901 0-19.204l25.901-25.901c5.303-5.303 13.901-5.303 19.204 0 5.303 5.303 5.303 13.901 0 19.204l-25.902 25.901c-5.303 5.303-13.901 5.303-19.203 0z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.459 248.665c5.303-5.303 13.901-5.303 19.204 0l25.901 25.901c5.303 5.303 5.303 13.901 0 19.204-5.303 5.303-13.901 5.303-19.204 0l-25.901-25.901c-5.303-5.303-5.303-13.901 0-19.204z",
    fill: "url(#SVGID_11_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76.838 505.798h-48.794c-10.333 0-18.71-8.377-18.71-18.71v-439.78c0-23.807 19.3-43.107 43.107-43.107 23.807 0 43.107 19.3 43.107 43.107v439.78c0 10.334-8.377 18.71-18.71 18.71z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.548 82.752h-86.213v9.019l86.213 86.213z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.548 135.524h-86.213v9.02l86.213 86.213z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.548 235.242h-86.213v9.02l86.213 86.213z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 114.421v20.708c0 4.738 2.572 8.774 6.09 9.59 13.653 3.167 29.477 4.979 46.351 4.979s32.698-1.812 46.351-4.979c3.518-.816 6.09-4.852 6.09-9.59v-20.708c0-5.994-4.044-10.566-8.503-9.601-13.091 2.834-28.047 4.443-43.938 4.443s-30.848-1.61-43.938-4.443c-4.459-.965-8.503 3.607-8.503 9.601z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 213.823v20.708c0 4.738 2.572 8.774 6.09 9.59 13.653 3.167 29.477 4.979 46.351 4.979s32.698-1.812 46.351-4.979c3.518-.816 6.09-4.852 6.09-9.59v-20.708c0-5.994-4.044-10.566-8.503-9.601-13.091 2.834-28.047 4.443-43.938 4.443s-30.848-1.61-43.938-4.443c-4.459-.965-8.503 3.607-8.503 9.601z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 60.757v20.708c0 4.738 2.572 8.774 6.09 9.59 13.653 3.167 29.477 4.979 46.351 4.979s32.698-1.812 46.351-4.979c3.518-.816 6.09-4.852 6.09-9.59v-20.708c0-5.994-4.044-10.566-8.503-9.601-13.09 2.834-28.046 4.444-43.938 4.444s-30.848-1.61-43.938-4.443c-4.459-.966-8.503 3.606-8.503 9.6z",
    fill: "url(#SVGID_18_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreetLights);
export default __webpack_public_path__ + "static/media/icon-street-lights.e54e7e0ff6eafd6b1b28e98e93acf03b.svg";
export { ForwardRef as ReactComponent };